import { ref, onBeforeUnmount } from "vue";

export const useCurrentTime = () => {
    const currentTime = ref(new Date());

    const updateCurrentTime = () => {
        currentTime.value = new Date();
    };

    const updateTimeInterval = setInterval(updateCurrentTime, 1000);

    onBeforeUnmount(() => {
        clearInterval(updateTimeInterval);
    });

    const formatTimeVN = () => {
        const date = currentTime.value;

        const days = [
            "Chủ Nhật,",
            "Thứ Hai,",
            "Thứ Ba,",
            "Thứ Tư,",
            "Thứ Năm,",
            "Thứ Sáu,",
            "Thứ Bảy,"
        ];

        const thu = days[date.getDay()];
        const time = date.toLocaleTimeString("vi-VN");
        const ngayThangNam = date.toLocaleDateString("vi-VN");

        return `${thu} ${time} ${ngayThangNam}`;
    };

    return {
        currentTime,
        formatTimeVN
    };
};
